import React from 'react';
import '../forms.css';
import FormLabel from '../formLabel';
import uuid from 'uuid/v4';

const Text = props => {
	const onChange = e => {
		if (typeof props.onChange === 'function') {
			props.onChange(e.target.value);
		}
	};

	const checkSubmit = e => {
		if (type === 'number' && [43, 69, 101].some(x => x === e.charCode)) {
			e.preventDefault();
			return false;
		}

		if (e.key === 'Enter' && typeof props.onSubmit === 'function') {
			props.onSubmit();
		}
	};

	const {
		label,
		labelFloat,
		help,
		infoHelp,
		error,
		warning,
		id,
		mandatory,
		maxLength,
		disabled,
		placeholder,
		value,
		step,
		type,
		inputSuffix,
		className,
		readonly,
		icon,
		...rest
	} = props;

	const guid = uuid();

	return (
		<div
			key={id || 'input'}
			data-testid={rest['data-testid']}
			id={id || 'input'}
			className={`form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}
		>
			<FormLabel {...props} htmlFor={`text-${id || guid}`} />
			<div className="flex flex-center text-input-holder">
				<input
					id={`text-${id || guid}`}
					role="textbox"
					autoComplete={type === 'password' ? 'new-password' : 'off'}
					maxLength={maxLength}
					disabled={disabled}
					readOnly={readonly}
					placeholder={placeholder}
					className={`form-control ${className ? className : ''}`}
					onChange={e => onChange(e)}
					onKeyUp={e => checkSubmit(e)}
					type={type || 'text'}
					value={value || (type === 'number' && value === 0) ? value : ''}
					step={step ? step : undefined}
				/>
				{icon && <i className={`fa ${icon}`} />}
				{inputSuffix && <span className="ml10">{inputSuffix}</span>}
			</div>
			{error && typeof error !== 'boolean' && (
				<span className="help-block">{typeof error === 'function' ? error() : error}</span>
			)}
			{warning && typeof warning !== 'boolean' && (
				<span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>
			)}
		</div>
	);
};

export default Text;
